import CallbackIconImg from "@icons/callback.svg";
import { Hideable } from "shared/UI/Hideable/Hideable";
import PeakSvg from "shared/assets/Icons/peak.svg";
import PhoneIconImg from "@icons/phone-call.svg";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import SpeechBubbleIconImg from "@icons/speech-bubble.svg";
import Button from "shared/UI/Buttons/Button";
import VideoCallIconImg from "@icons/video-call-square.svg";
import { useTranslation } from "react-i18next";
import { useWisdomLite } from "core/hooks/useWisdomLite";

export const WisdomLiteNotice = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "support.wisdomLite" });
  const { isWisdomLite } = useWisdomLite();
  const handleFindMoreButtonClick = () => {
    const url = "mailto:" + t("contactAddress") + "?subject=" + t("emailSubject");
    window.open(url);
  };

  const supportData = [
    {
      icon: SpeechBubbleIconImg,
      text: t("description.line2"),
    },
    {
      icon: PhoneIconImg,
      text: t("description.line3"),
    },
    {
      icon: VideoCallIconImg,
      text: t("description.line4"),
    },
    {
      icon: CallbackIconImg,
      text: t("description.line5"),
    },
  ];

  return (
    <Hideable hidden={!isWisdomLite}>
      <div className="w-full py-4 md:order-3 md:p-4">
        <RoundedCard padding="p-6">
          <img src={PeakSvg} alt={"Peak Icon"} className={"mb-4 pl-[1px]"} />
          <h2 className="mb-2">{t("title")}</h2>
          <div className="flex flex-col gap-6">
            <p dangerouslySetInnerHTML={{ __html: t("description.line1") }} />
            <div className="space-y-4">
              {supportData.map((data) => {
                return (
                  <div className="flex space-x-4 items-center h-[30px]">
                    <img src={data.icon} alt={data.text} width={26} height={26} />
                    <p>{data.text}</p>
                  </div>
                );
              })}
            </div>
            <p>{t("description.line6")}</p>
            <Button onClick={() => handleFindMoreButtonClick()} text={t("buttonText")} />
          </div>
        </RoundedCard>
      </div>
    </Hideable>
  );
};
